import { NgModule } from '@angular/core';

import { ConfirmationService, MessageService } from 'primeng/api';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipsModule } from 'primeng/chips';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { FileUploadModule } from 'primeng/fileupload';
import { InplaceModule } from 'primeng/inplace';
import { InputMaskModule } from 'primeng/inputmask';
import { MenuModule } from 'primeng/menu';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { MultiSelectModule } from 'primeng/multiselect';
import { PaginatorModule } from 'primeng/paginator';
import { PickListModule } from 'primeng/picklist';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SidebarModule } from 'primeng/sidebar';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { TriStateCheckboxModule } from 'primeng/tristatecheckbox';
import { VirtualScrollerModule } from 'primeng/virtualscroller';


@NgModule({
  declarations: [],
  providers: [
    MessageService,
    ConfirmationService,
  ],
  exports: [
    AutoCompleteModule,
    CalendarModule,
    ConfirmDialogModule,
    DialogModule,
    DynamicDialogModule,
    FileUploadModule,
    InputMaskModule,
    MenuModule,
    MessagesModule,
    MessageModule,
    MultiSelectModule,
    PaginatorModule,
    PickListModule,
    ProgressSpinnerModule,
    SidebarModule,
    TableModule,
    TabViewModule,
    ToastModule,
    TooltipModule,
    ChipsModule,
    CheckboxModule,
    TriStateCheckboxModule,
    VirtualScrollerModule,
    InplaceModule
  ]
})
export class PrimeNGUIModule { }
